import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import { Box } from "@mui/material";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import { usePathology } from "./PathologyRoot";

export default function PathologyStudentSidebar({
  compact = true,
  minWidth = 280,
  maxWidth = 340,
}) {
  const { student } = usePathology();
  const { diseases, selectedDiseaseId, setSelectedDiseaseId, hasDiseases } =
    student;
  const selectedDisease = diseases.find((d) => d.id === selectedDiseaseId);

  if (!hasDiseases) return null;

  return (
    <Card
      style={{
        marginBottom: 16,
        minWidth,
        maxWidth,
        width: "100%",
      }}
    >
      <MDBox p={2}>
        <MDTypography
          variant={compact ? "button" : "h6"}
          fontWeight={compact ? "bold" : "regular"}
        >
          Diseases
        </MDTypography>
        <Divider sx={{ my: 1.5 }} />
        <RadioGroup
          value={selectedDiseaseId}
          onChange={(e) => setSelectedDiseaseId(e.target.value)}
        >
          <FormControlLabel
            value=""
            control={<Radio size="small" />}
            label={
              <MDTypography variant="caption" color="text">
                Normal (no overlay)
              </MDTypography>
            }
          />
          {diseases.map((d) => (
            <FormControlLabel
              key={d.id}
              value={d.id}
              control={<Radio size="small" />}
              label={
                <MDTypography variant="caption" color="text">
                  {d.name}
                  {d.severity ? ` (${d.severity})` : ""}
                </MDTypography>
              }
            />
          ))}
        </RadioGroup>
        {selectedDisease ? (
          <Box
            sx={{
              mt: 1.5,
              p: 1.25,
              borderRadius: 1,
              bgcolor: "grey.50",
              border: "1px solid",
              borderColor: "divider",
            }}
          >
            <MDTypography variant="caption" fontWeight="bold" display="block">
              {selectedDisease.name}
            </MDTypography>
            {selectedDisease.description ? (
              <MDTypography
                variant="caption"
                color="text"
                display="block"
                sx={{ mt: 0.75, lineHeight: 1.45 }}
              >
                {selectedDisease.description}
              </MDTypography>
            ) : null}
          </Box>
        ) : null}
      </MDBox>
    </Card>
  );
}
